/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/products/product-variant
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCartLineItemKey,
  ShopifyCartLineItemToProductVariantKey,
  ShopifyCheckoutLineItemKey,
  ShopifyCheckoutLineItemToVariantKey,
  ShopifyDiscountCustomerBuysProductVariantKey,
  ShopifyDiscountCustomerBuysProductVariantToDiscountKey,
  ShopifyDiscountCustomerBuysProductVariantToProductVariantKey,
  ShopifyDiscountCustomerGetsProductVariantKey,
  ShopifyDiscountCustomerGetsProductVariantToDiscountKey,
  ShopifyDiscountCustomerGetsProductVariantToProductVariantKey,
  ShopifyDiscountKey,
  ShopifyDiscountToCustomerBuysProductVariantKey,
  ShopifyDiscountToCustomerGetsProductVariantKey,
  ShopifyDraftOrderLineItemKey,
  ShopifyDraftOrderLineItemToProductVariantKey,
  ShopifyFileKey,
  ShopifyFileToProductVariantKey,
  ShopifyFulfillmentOrderLineItemKey,
  ShopifyFulfillmentOrderLineItemToProductVariantKey,
  ShopifyInventoryItemKey,
  ShopifyOrderLineItemKey,
  ShopifyOrderLineItemToProductVariantKey,
  ShopifyPriceListPriceKey,
  ShopifyPriceListPriceToProductVariantKey,
  ShopifyProductImageKey,
  ShopifyProductKey,
  ShopifyProductVariantKey,
  ShopifyProductVariantMediaKey,
  ShopifyProductVariantMediaToFileKey,
  ShopifyProductVariantMediaToProductVariantKey,
  ShopifyProductVariantToCartLineItemsKey,
  ShopifyProductVariantToCheckoutLineItemsKey,
  ShopifyProductVariantToCustomerBuysProductVariantKey,
  ShopifyProductVariantToCustomerGetsProductVariantKey,
  ShopifyProductVariantToDraftOrderLineItemsKey,
  ShopifyProductVariantToFileKey,
  ShopifyProductVariantToFulfillmentOrderLineItemsKey,
  ShopifyProductVariantToInventoryItemKey,
  ShopifyProductVariantToOrderLineItemsKey,
  ShopifyProductVariantToPriceListPriceKey,
  ShopifyProductVariantToProductImageKey,
  ShopifyProductVariantToProductKey,
  ShopifyProductVariantToQuantityPriceBreakKey,
  ShopifyProductVariantToSellingPlanGroupKey,
  ShopifyProductVariantToShopKey,
  ShopifyProductVariantToSubscriptionLinesKey,
  ShopifyQuantityPriceBreakKey,
  ShopifyQuantityPriceBreakToProductVariantKey,
  ShopifySellingPlanGroupKey,
  ShopifySellingPlanGroupProductVariantKey,
  ShopifySellingPlanGroupProductVariantToProductVariantKey,
  ShopifySellingPlanGroupProductVariantToSellingPlanGroupKey,
  ShopifySellingPlanGroupToProductVariantKey,
  ShopifyShopKey,
  ShopifySubscriptionLineKey,
  ShopifySubscriptionLineToProductVariantKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

// we removed graphql only fields from the model spec which changes how the static keys are generated. these are here so that they remain the same
const selectedOptionsKey = "ModelField-DataModel-Shopify-ProductVariant-__gadget_graphql_selected_options";
const selectedOptionsStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-ProductVariant-__gadget_graphql_selected_options-initial";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyProductVariantKey,
  "2022-01": {
    name: "Shopify Product Variant",
    graphQLTypename: "ProductVariant",
    hasMetafields: true,
    fields: [
      {
        name: "Barcode",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "barcode" } },
      },
      {
        name: "Compare At Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "compare_at_price" } },
      },
      {
        name: "Fulfillment Service",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfillment_service" } },
      },
      {
        name: "Grams",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "grams" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Draft Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyProductVariantToDraftOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderLineItemKey,
          inverseFieldKey: ShopifyDraftOrderLineItemToProductVariantKey,
        },
      },
      {
        name: "Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyProductVariantToOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToProductVariantKey,
        },
      },
      {
        name: "Product Image",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToProductImageKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "image_id" } },
        configuration: {
          relatedModelKey: ShopifyProductImageKey,
        },
      },
      {
        name: "Inventory Item",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToInventoryItemKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "inventory_item_id" } },
        configuration: {
          relatedModelKey: ShopifyInventoryItemKey,
        },
      },
      {
        name: "Inventory Management",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "inventory_management" } },
      },
      {
        name: "Inventory Policy",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "inventory_policy" } },
      },
      {
        name: "Inventory Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "inventory_quantity" } },
      },
      {
        name: "Inventory Quantity Adjustment",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "inventory_quantity_adjustment" } },
      },
      {
        name: "Old Inventory Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "old_inventory_quantity" } },
      },
      {
        name: "Option 1",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "option1" } },
      },
      {
        name: "Option 2",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "option2" } },
      },
      {
        name: "Option 3",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "option3" } },
      },
      {
        name: "Position",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "position" } },
      },
      {
        name: "Presentment Prices",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "presentment_prices" } },
      },
      {
        name: "Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "price" } },
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToProductKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "product_id" } },
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
      {
        name: "Requires Shipping",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "requires_shipping" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "SKU",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "sku" } },
      },
      {
        name: "Subscription Lines",
        fieldType: FieldType.HasMany,
        key: ShopifyProductVariantToSubscriptionLinesKey,
        configuration: {
          relatedModelKey: ShopifySubscriptionLineKey,
          inverseFieldKey: ShopifySubscriptionLineToProductVariantKey,
        },
      },
      {
        name: "Tax Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_code" } },
      },
      {
        name: "Taxable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "taxable" } },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "title" } },
      },
      {
        name: "Weight",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "weight" } },
      },
      {
        name: "Weight Unit",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "weight_unit" } },
      },
      {
        name: "Cart Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyProductVariantToCartLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyCartLineItemKey,
          inverseFieldKey: ShopifyCartLineItemToProductVariantKey,
        },
      },
      {
        name: "Checkout Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyProductVariantToCheckoutLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutLineItemKey,
          inverseFieldKey: ShopifyCheckoutLineItemToVariantKey,
        },
      },
      {
        name: "Selling Plan Groups",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductVariantToSellingPlanGroupKey,
        configuration: {
          joinModelKey: ShopifySellingPlanGroupProductVariantKey,
          relatedModelKey: ShopifySellingPlanGroupKey,
          inverseJoinModelFieldKey: ShopifySellingPlanGroupProductVariantToProductVariantKey,
          inverseRelatedModelFieldKey: ShopifySellingPlanGroupProductVariantToSellingPlanGroupKey,
          inverseFieldKey: ShopifySellingPlanGroupToProductVariantKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "product" },
  },
  "2023-07": {
    fields: [
      {
        name: "Customer Gets Through Discounts",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductVariantToCustomerGetsProductVariantKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerGetsProductVariantKey,
          relatedModelKey: ShopifyDiscountKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerGetsProductVariantToProductVariantKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerGetsProductVariantToDiscountKey,
          inverseFieldKey: ShopifyDiscountToCustomerGetsProductVariantKey,
        },
      },
      {
        name: "Customer Buys Through Discounts",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductVariantToCustomerBuysProductVariantKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerBuysProductVariantKey,
          relatedModelKey: ShopifyDiscountKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerBuysProductVariantToProductVariantKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerBuysProductVariantToDiscountKey,
          inverseFieldKey: ShopifyDiscountToCustomerBuysProductVariantKey,
        },
      },
    ],
  },
  "2024-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "Barcode",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "barcode", graphQLFieldKey: "barcode" } },
      },
      {
        name: "Compare At Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "compare_at_price", graphQLFieldKey: "compareAtPrice" } },
      },
      {
        name: "Fulfillment Service",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "fulfillment_service",
            graphQLFieldKey: "fulfillmentService",
            graphQLSelection: "handle",
            deprecated: true,
          },
        },
      },
      {
        name: "Product Image",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToProductImageKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "image_id", graphQLFieldKey: "image", graphQLSelection: "id" },
        },
        configuration: {
          relatedModelKey: ShopifyProductImageKey,
        },
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToProductKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "product_id", graphQLFieldKey: "productId", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
      {
        name: "Inventory Item",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToInventoryItemKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "inventory_item_id", graphQLFieldKey: "inventoryItem", graphQLSelection: "id" },
        },
        configuration: {
          relatedModelKey: ShopifyInventoryItemKey,
        },
      },
      {
        name: "Inventory Management",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "inventory_management", graphQLFieldKey: "inventoryManagement", deprecated: true },
        },
      },
      {
        name: "Inventory Policy",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "inventory_policy", graphQLFieldKey: "inventoryPolicy", isShopifyEnum: true },
        },
      },
      {
        name: "Inventory Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "inventory_quantity", graphQLFieldKey: "inventoryQuantity" } },
      },
      {
        name: "Inventory Quantity Adjustment",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "inventory_quantity_adjustment" } },
        isDeleted: true,
      },
      {
        name: "Old Inventory Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "old_inventory_quantity" } },
        isDeleted: true,
      },
      {
        name: "Option 1",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "option1", graphQLFieldKey: "option1", skipGraphQLSelection: true },
        },
      },
      {
        name: "Option 2",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "option2", graphQLFieldKey: "option2", skipGraphQLSelection: true },
        },
      },
      {
        name: "Option 3",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "option3", graphQLFieldKey: "option3", skipGraphQLSelection: true },
        },
      },
      {
        key: selectedOptionsKey,
        initialStorageEpochKey: selectedOptionsStorageEpochKey,
        name: "Selected Options",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "selectedOptions",
            graphQLSelection: `
        name
        value
        optionValue {
          id
          hasVariants
          linkedMetafieldValue
          name
          swatch {
            color
            image {
              id
              image {
                id
                src
              }
            }
          }
        }
        `,
          },
        },
      },
      {
        name: "Position",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "position", graphQLFieldKey: "position" } },
      },
      {
        name: "Price",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "price", graphQLFieldKey: "price" } },
      },
      {
        name: "Requires Shipping",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "requires_shipping", graphQLFieldKey: "requiresShipping", deprecated: true },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at", graphQLFieldKey: "createdAt" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at", graphQLFieldKey: "updatedAt" } },
      },
      {
        name: "SKU",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "sku", graphQLFieldKey: "sku" } },
      },
      {
        name: "Tax Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_code", graphQLFieldKey: "taxCode" } },
      },
      {
        name: "Taxable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "taxable", graphQLFieldKey: "taxable" } },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "title", graphQLFieldKey: "title" } },
      },
      {
        name: "Grams",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "grams" } },
        isDeleted: true,
      },
      {
        name: "Weight",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "weight", graphQLFieldKey: "weight", deprecated: true } },
      },
      {
        name: "Weight Unit",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "weight_unit", graphQLFieldKey: "weightUnit", deprecated: true },
        },
      },
      {
        name: "Price List Price",
        fieldType: FieldType.HasMany,
        key: ShopifyProductVariantToPriceListPriceKey,
        configuration: {
          relatedModelKey: ShopifyPriceListPriceKey,
          inverseFieldKey: ShopifyPriceListPriceToProductVariantKey,
        },
      },
      {
        name: "Quantity Price Breaks",
        fieldType: FieldType.HasMany,
        key: ShopifyProductVariantToQuantityPriceBreakKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyQuantityPriceBreakKey,
          inverseFieldKey: ShopifyQuantityPriceBreakToProductVariantKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "products",
      resource: "product.variants",
    },
  },
  "2024-07": {
    fields: [
      {
        name: "Inventory Management",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "inventory_management", graphQLFieldKey: "inventoryManagement" },
        },
        isDeleted: true,
      },
      {
        name: "Requires Shipping",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "requires_shipping", graphQLFieldKey: "requiresShipping" },
        },
        isDeleted: true,
      },
      {
        name: "Weight",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "weight", graphQLFieldKey: "weight" } },
        isDeleted: true,
      },
      {
        name: "Weight Unit",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "weight_unit", graphQLFieldKey: "weightUnit" },
        },
        isDeleted: true,
      },
      {
        name: "Fulfillment Service",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "fulfillment_service",
            graphQLFieldKey: "fulfillmentService",
            graphQLSelection: "handle",
          },
        },
        isDeleted: true,
      },
      {
        name: "Fulfillment Order Line Item",
        fieldType: FieldType.HasMany,
        key: ShopifyProductVariantToFulfillmentOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderLineItemKey,
          inverseFieldKey: ShopifyFulfillmentOrderLineItemToProductVariantKey,
        },
      },
      {
        name: "Media",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductVariantToFileKey,
        configuration: {
          joinModelKey: ShopifyProductVariantMediaKey,
          relatedModelKey: ShopifyFileKey,
          inverseJoinModelFieldKey: ShopifyProductVariantMediaToProductVariantKey,
          inverseRelatedModelFieldKey: ShopifyProductVariantMediaToFileKey,
          inverseFieldKey: ShopifyFileToProductVariantKey,
          dependent: "delete",
        },
      },
    ],
  },
  "2025-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Available For Sale",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "availableForSale",
          },
        },
      },
      {
        name: "Barcode",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "barcode",
            graphQLFieldKey: "barcode",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Compare At Price",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "compare_at_price",
            graphQLFieldKey: "compareAtPrice",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Product Image",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToProductImageKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "image_id",
            graphQLFieldKey: "image",
            graphQLSelection: "id",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyProductImageKey,
        },
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToProductKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "product_id",
            graphQLFieldKey: "productId",
            skipGraphQLSelection: true,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
      {
        name: "Inventory Item",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductVariantToInventoryItemKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "inventory_item_id",
            graphQLFieldKey: "inventoryItem",
            graphQLSelection: "id",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyInventoryItemKey,
        },
      },
      {
        name: "Inventory Policy",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "inventory_policy",
            graphQLFieldKey: "inventoryPolicy",
            isShopifyEnum: true,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Inventory Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "inventory_quantity",
            graphQLFieldKey: "inventoryQuantity",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Option 1",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "option1",
            graphQLFieldKey: "option1",
            skipGraphQLSelection: true,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Option 2",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "option2",
            graphQLFieldKey: "option2",
            skipGraphQLSelection: true,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Option 3",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "option3",
            graphQLFieldKey: "option3",
            skipGraphQLSelection: true,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Position",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "position",
            graphQLFieldKey: "position",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Price",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "price",
            graphQLFieldKey: "price",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "SKU",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "sku",
            graphQLFieldKey: "sku",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Taxable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "taxable",
            graphQLFieldKey: "taxable",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "title",
            graphQLFieldKey: "title",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
    ],
  },
  "2025-10": {
    fields: [
      {
        name: "Tax Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_code", graphQLFieldKey: "taxCode", deprecated: true } },
      },
    ],
  },
};

export const ShopifyProductVariant = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
